<template>
  <div :class="[`frame-52`, className || ``]">
    <div class="social-icons">
      <div class="overlap-group-container">
        <div class="overlap-group-16">
          <img
            class="icon-twitter"
            src="/otplanding/path-18@2x.png"
            alt="icon-twitter"
          />
        </div>
        <div class="overlap-group1-8">
          <img
            class="path-18"
            src="/otplanding/path-19@2x.png"
            alt="Path"
          />
        </div>
        <div class="overlap-group2">
          <img
            class="path-19"
            src="/otplanding/path-20@2x.png"
            alt="Path"
          />
        </div>
        <div class="overlap-group3">
          <div class="oval"></div>
          <img
            class="shape-8"
            src="/otplanding/shape-6@2x.png"
            alt="Shape"
          />
          <img
            class="shape-9"
            src="/otplanding/shape-7@2x.png"
            alt="Shape"
          />
        </div>
        <div class="overlap-group4">
          <img
            class="icon-linkedin"
            src="/otplanding/shape-8@2x.png"
            alt="icon-linkedin"
          />
        </div>
      </div>
    </div>
    <p class="x2023-protokolio valign-text-bottom inter-normal-white-14px mb-5">
      <span
        ><span class="span-17 inter-normal-gull-gray-14px"></span
        ><span class="span-17 inter-medium-link-water-14px">protokol.io</span
        ><span class="span-17 inter-normal-gull-gray-14px">&nbsp;&nbsp;2023 <br />sva prava zadržana
          <br /> <a href="https://envoy.fra1.cdn.digitaloceanspaces.com/tos/politika_privatnosti_protokol_01062023.pdf" target="_blank">Politika privatnosti</a>
        </span>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Frame52",
  props: ["className"],
};
</script>

<style>
.frame-52 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin: 0 auto;
}

.social-icons {
  height: 33px;
  min-width: 205.55px;
  position: relative;
}

.overlap-group-container {
  align-items: flex-end;
  display: flex;
  gap: 13px;
  height: 33px;
  justify-content: center;
  min-width: 206px;
}

.overlap-group-16 {
  align-items: flex-end;
  align-self: flex-start;
  background-color: var(--shark);
  border-radius: 16px;
  display: flex;
  height: 34px;
  margin-top: -1px;
  min-width: 31px;
  padding: 10px 8.3px;
}

.icon-twitter {
  height: 13px;
  width: 15px;
}

.overlap-group1-8 {
  align-items: flex-end;
  background-color: var(--shark);
  border-radius: 16px;
  display: flex;
  height: 34px;
  justify-content: flex-end;
  margin-bottom: -1px;
  min-width: 31px;
  padding: 9.2px 8.2px;
}

.path-18,
.icon-linkedin {
  height: 16px;
  width: 15px;
}

.overlap-group2 {
  align-items: center;
  background-color: var(--shark);
  border-radius: 16px;
  display: flex;
  height: 34px;
  margin-bottom: -1px;
  min-width: 31px;
  padding: 0 11.1px;
}

.path-19 {
  height: 16px;
  width: 9px;
}

.overlap-group3 {
  background-color: var(--shark);
  border-radius: 16px;
  height: 34px;
  margin-bottom: -1px;
  position: relative;
  width: 31px;
}

.oval {
  background-color: var(--blueberry);
  border-radius: 0.88px/0.96px;
  height: 2px;
  left: 19px;
  position: absolute;
  top: 12px;
  width: 2px;
}

.shape-8 {
  height: 8px;
  left: 12px;
  position: absolute;
  top: 13px;
  width: 7px;
}

.shape-9 {
  height: 16px;
  left: 8px;
  position: absolute;
  top: 9px;
  width: 15px;
}

.overlap-group4 {
  align-items: center;
  background-color: var(--shark);
  border-radius: 16px;
  display: flex;
  height: 34px;
  justify-content: flex-end;
  margin-bottom: -1px;
  min-width: 31px;
  padding: 0 8.2px;
}

.x2023-protokolio {
  align-self: stretch;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-align: center;
}

.frame-52.frame-52-1 {
  left: 0;
  top: 618px;
}
</style>
